// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__MT6rJ","container":"styles_container__36bcr","title":"styles_title__1B8Vm","wrapper":"styles_wrapper__3H0eZ","answer":"styles_answer__1kjTw"};